var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.59494C7.9103 4.59494 4.59494 7.9103 4.59494 12C4.59494 13.7666 5.21355 15.3887 6.24597 16.6615C7.47421 14.8694 9.6039 13.699 12 13.699C14.3961 13.699 16.5258 14.8694 17.754 16.6615C18.7865 15.3887 19.4051 13.7666 19.4051 12C19.4051 7.9103 16.0897 4.59494 12 4.59494ZM16.5951 17.8073C15.7025 16.3223 13.9902 15.2939 12 15.2939C10.0098 15.2939 8.29752 16.3223 7.40495 17.8073C8.66755 18.8077 10.264 19.4051 12 19.4051C13.736 19.4051 15.3325 18.8077 16.5951 17.8073ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM12 7.32911C11.1821 7.32911 10.519 7.99219 10.519 8.81013C10.519 9.62807 11.1821 10.2911 12 10.2911C12.8179 10.2911 13.481 9.62807 13.481 8.81013C13.481 7.99219 12.8179 7.32911 12 7.32911ZM8.92405 8.81013C8.92405 7.11133 10.3012 5.73418 12 5.73418C13.6988 5.73418 15.0759 7.11133 15.0759 8.81013C15.0759 10.5089 13.6988 11.8861 12 11.8861C10.3012 11.8861 8.92405 10.5089 8.92405 8.81013Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineUser);
export default __webpack_public_path__ + "static/media/line-user.57002164d671d9964ac2cded56801ef0.svg";
export { ForwardRef as ReactComponent };